<template>
  <v-row no-gutters>
    <v-col cols="6" class="pr-1">
      <v-menu
        ref="datePicker"
        :close-on-content-click="false"
        v-model="dateDialog"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        :disabled="readonly"
      >
        <template #activator="{on}">
          <v-text-field v-on="on" v-model="date" :label="contextDateLabel" prepend-icon="" :error-messages="dateTimeValidation" readonly />
        </template>
        <v-date-picker v-model="date" no-title scrollable @input="$refs.datePicker.save(date)" first-day-of-week="1" :locale="locale" />
      </v-menu>
    </v-col>
    <v-col cols="6" class="pl-1">
      <v-menu
        ref="timePicker"
        :disabled="readonly"
        :close-on-content-click="false"
        v-model="timeDialog"
        :nudge-right="40"
        :return-value.sync="time"
        transition="scale-transition"
        offset-y
        max-width="290px"
        min-width="290px"
      >
        <template #activator="{on}">
          <v-text-field v-on="on" v-model="time" :label="contextTimeLabel" :error-messages="timeValidation" prepend-icon="" readonly />
        </template>
        <v-time-picker v-model="time" @click:minute="$refs.timePicker.save(time)" format="24hr" :locale="locale" />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "DateTimePickerComputed",
  props: {
    readonly: {
      required: false,
      default: false
    },
    dateTimeModel: {
      required: true
    },
    dateLabel: {
      required: true,
      default: false
    },
    timeLabel: {
      required: false,
      default: false
    },
    timeRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    dateTimeValidation: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data: () => ({
    dateDialog: false,
    timeDialog: false,
    model: "",
    validationError: false,
    validationMessage: [],
    validationTime: []
  }),
  watch: {
    dateDialog: function(oldModel, newModel) {
      if (newModel === true) {
        this.timeDialog = true;
      }
    },
    timeValidation() {}
  },
  methods: {
    minutesLimit: v => !(v % 5 !== 0),
    addZeroBefore: function(n) {
      return (n < 10 ? "0" : "") + n;
    }
  },
  computed: {
    contextDateLabel() {
      if (this.dateLabel === false) {
        return this.$t("global.date");
      }
      return this.dateLabel;
    },
    contextTimeLabel() {
      if (this.timeLabel === false) {
        return this.$t("global.time");
      }
      return this.timeLabel;
    },
    locale() {
      return this.$i18n.locale;
    },
    date: {
      set: function(value) {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            this.dateTime = value + " " + dateTime[1];
            return this.dateTime;
          }
        }
        this.dateTime = value + " ";
      },
      get: function() {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            return dateTime[0];
          }
        }
        return null;
      }
    },
    time: {
      set: function(value) {
        if (this.dateTime != null && value != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            this.dateTime = dateTime[0] + " " + value;
            return value;
          }
        }
        //this.dateTime = value;
      },
      get: function() {
        if (this.dateTime != null && this.dateTime.length > 1) {
          const dateTime = this.dateTime.split(" ");
          if (dateTime.length > 1) {
            if (dateTime[1].length < 5) return null;
            return dateTime[1];
          }
        }
        return null;
      }
    },
    dateTime: {
      set: function(value) {
        this.$emit("update:dateTimeModel", value);
      },
      get: function() {
        return this.dateTimeModel;
      }
    },
    timeValidation() {
      let result = [];
      if (this.timeRequired && this.time == null) {
        result.push(this.$t("components.datetime.timeIsRequired"));
      }
      return result;
    }
  }
};
</script>

<style scoped></style>
